import React from 'react'
import { Grid, LinearProgress } from '@mui/material'
import LogoImg from '../../assets/logo.png'
import useWidth from '../../hooks/useWidth'
import { LeftColumn, RightColumn, useStyles } from './styles'
import { lgDown, mdUp } from '../../utils/breakpoints'
import { Box } from '@mui/system'

const Step = ({ open, children, img, bgx, bgy, sending, message }) => {
  const classes = useStyles()
  const width = useWidth()

  return open ? (
    <Grid container className={classes.slide}>
      <LeftColumn
        item
        xs={12}
        lg={5}
        imagebg={img}
        bgx={bgx}
        bgy={bgy}
        alignItems={mdUp(width) ? 'flex-end' : 'center'}
        justifyContent={lgDown(width) ? 'center' : 'flex-start'}
      >
        <img src={LogoImg} className={classes.logo} alt='logo' />
      </LeftColumn>
      <RightColumn item xs={12} lg={7}>
        <h3 className={classes.formTile}>Client Feedback</h3>
        <p className={classes.formSubtitle}>
          {message || 'Our relationship with your community is very important to us.'}
        </p>
        {sending && (
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        )}
        {children}
      </RightColumn>
    </Grid>
  ) : null
}

export default Step
